export function normalizeFolderIds(folderIds?: string[]): string[] {
  const validFolderIds = (folderIds ?? []).filter((id) => id.length > 0);
  return [...new Set(validFolderIds)];
}
